import { type SvgProps, SvgWrapper } from '../utils';
export function SearchIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M18.25 11C18.25 6.99594 15.0041 3.75 11 3.75C6.99594 3.75 3.75 6.99594 3.75 11C3.75 15.0041 6.99594 18.25 11 18.25C15.0041 18.25 18.25 15.0041 18.25 11ZM19.75 11C19.75 13.1462 18.9757 15.1106 17.6934 16.6328L21.5303 20.4697C21.8232 20.7626 21.8232 21.2374 21.5303 21.5303C21.2374 21.8232 20.7626 21.8232 20.4697 21.5303L16.6328 17.6934C15.1106 18.9757 13.1462 19.75 11 19.75C6.16751 19.75 2.25 15.8325 2.25 11C2.25 6.16751 6.16751 2.25 11 2.25C15.8325 2.25 19.75 6.16751 19.75 11Z" />
    </SvgWrapper>
  );
}
